import { render, staticRenderFns } from "./IdentifyFace.vue?vue&type=template&id=eff72194&scoped=true"
import script from "./IdentifyFace.vue?vue&type=script&lang=js"
export * from "./IdentifyFace.vue?vue&type=script&lang=js"
import style0 from "./IdentifyFace.vue?vue&type=style&index=0&id=eff72194&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eff72194",
  null
  
)

export default component.exports